import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=c7a7245c&"
import script from "./NotificationEdit.vue?vue&type=script&lang=ts&"
export * from "./NotificationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports